/* =========================================================================
   Aunty Cherish — "Add a blend" cart-drawer upsell (2026-06-14)
   One-tap add for the curated blend tiles in snippets/cart-complete-set.liquid.
   Delegated on document (survives the drawer re-render). After adding, calls
   window.refreshCart() (component-cart.js) which re-fetches ?section_id=helper-cart,
   re-renders #AjaxCartForm (this block + items + gift picker) and re-opens the
   drawer, so the progress line, kit gate and tiles all update live.
   ========================================================================= */
(function () {
  'use strict';

  function addPack(id, btn) {
    if (!id) return;
    if (btn && btn.getAttribute('aria-busy') === 'true') return;
    if (btn) { btn.setAttribute('aria-busy', 'true'); btn.classList.add('is-loading'); }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        // refreshCart re-renders the whole drawer (incl. this block) and re-opens it.
        if (typeof window.refreshCart === 'function') {
          window.refreshCart();
        } else {
          // Fallback: nudge the theme + gift logic, then hard refresh as last resort.
          document.dispatchEvent(new Event('cart-updated'));
        }
        // Let cart-gift.js reconcile the kit gate too (harmless if nothing changes).
        document.dispatchEvent(new Event('cart-updated'));
      })
      .catch(function () {
        if (btn) { btn.removeAttribute('aria-busy'); btn.classList.remove('is-loading'); }
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-ac-addpack]');
    if (!btn) return;
    e.preventDefault();
    addPack(Number(btn.getAttribute('data-ac-addpack')), btn);
  }, true);
})();
